module.exports = __webpack_public_path__ + "static/media/03_hero_mobile.bb923726.jpg";